import { Box, Button, Flex, Text } from "@chakra-ui/react";
import React, { Suspense, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "axios-hooks";

import LocationTabs from "./tabs/LocationTabs";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import logger from "infra/logger";

const ViewChargingStation = () => {
  const { id } = useParams(); //shoulf fetch station details with this id
  const navigate = useNavigate();
  const initialTabIndex = 5;

  const [station, SetStation] = useState(null);
  const [{ data, loading, error }, getStation] = useAxios(
    { method: "GET", url: `/api/locations/${id}` },
    { manual: true }
  );
  const getChargingStation = async () => {
    try {
      const response = await getStation();
      SetStation(response.data.data);
    } catch (error) {
      logger.log(error);
    }
  };

  useEffect(() => {
    getChargingStation();
  }, []);

  return (
    <Box px={{ base: 2, md: 4 }}>
      <Suspense fallback={<LoadingSpinner />}>
        <Flex
          mb={{ base: 3, md: 5 }}
          direction={{ base: "column", sm: "row" }}
          alignItems={{ base: "flex-start", sm: "center" }}
          justifyContent={"space-between"}
          gap={{ base: 2, sm: 0 }}
        >
          <Text
            ml={{ base: 0, sm: 5 }}
            fontWeight={700}
            fontSize={{ base: "xl", sm: "2xl", md: "3xl" }}
            color="brand.500"
            textAlign={{ base: "left", sm: "center" }}
            noOfLines={2}
          >
            {station?.Name}
          </Text>
          <Button
            bgColor={"brand.500"}
            _hover={{ bgColor: "#d44e00" }}
            onClick={() => navigate(-1)}
            marginLeft={{ base: 0, sm: "auto" }}
            color={"white"}
            px={{ base: 4, md: 5 }}
            py={{ base: 2, md: 3 }}
            fontSize={{ base: "sm", md: "md" }}
            borderRadius={8}
            w={{ base: "full", sm: "auto" }}
          >
            Back
          </Button>
        </Flex>

        <LocationTabs
          id={id}
          data={station}
          getStation={getChargingStation}
          initialTabIndex={initialTabIndex}
        />
      </Suspense>
    </Box>
  );
};

export default ViewChargingStation;
